import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import {
  CheckHandedIn,
  CircleStarted,
  LoaderNoStarted,
} from 'src/components/icons';
import { getMSAssignmentsStatusLabelMap } from 'src/constants/assignments.constants';
import {
  AssignmentStatus,
  MSAssignmentsStatusOptions,
} from 'src/interfaces/assignment.types';
import { getAmpConfigFlags } from 'src/services/amp-config.service';

import './assignment-status.scss';

type AssignmentStatusBadgeProps = {
  assignmentStatus?: AssignmentStatus;
};

export const AssignmentStatusBadge = ({
  assignmentStatus = AssignmentStatus.TODO,
}: AssignmentStatusBadgeProps) => {
  const { t } = useTranslation();
  const MSAssignmentsStatusLabelMap = getMSAssignmentsStatusLabelMap(t);

  // TODO: Remove the feature flag after RFS.
  const isUpdatedMSViewEnabled = getAmpConfigFlags().isUpdatedMSViewEnabled;

  const getStatusLabel = (status: AssignmentStatus) => {
    if (MSAssignmentsStatusOptions.HANDED_IN.includes(status)) {
      return (
        <>
          <CheckHandedIn />{' '}
          <span className="assignment-status-badge__label">
            {MSAssignmentsStatusLabelMap[MSAssignmentsStatusOptions.HANDED_IN]}
          </span>
        </>
      );
    }

    if (MSAssignmentsStatusOptions.STARTED.includes(status)) {
      return (
        <>
          <CircleStarted />{' '}
          <span className="assignment-status-badge__label">
            {MSAssignmentsStatusLabelMap[MSAssignmentsStatusOptions.STARTED]}
          </span>
        </>
      );
    }

    return (
      <>
        <LoaderNoStarted />{' '}
        <span className="assignment-status-badge__label">
          {MSAssignmentsStatusLabelMap[MSAssignmentsStatusOptions.NOT_STARTED]}
        </span>
      </>
    );
  };

  return (
    <span
      className={clsx('assignment-status-badge', {
        'assignment-status-badge--updated-ms-view': isUpdatedMSViewEnabled,
      })}
    >
      {getStatusLabel(assignmentStatus)}
    </span>
  );
};
